module.exports = __webpack_public_path__ + "img/custom_logo.svg";